<div class="chart-parent" [attr.id]="idPrefix"></div>
<div
    *ngIf="showHint()"
    class="px-5 d-flex align-items-center h-100 text-center"
>
    <p>{{ 'charts.messages.noDataAvailable' | translate }}</p>
</div>
